/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import OngoingLottie from '@/assets/lottie/loading-dot-ongoing.json';
import WaitLottie from '@/assets/lottie/loading-dot-wait.json';
import CustomLottieIcon from '@/components/atom/CustomLottieIcon';
import DefaultDoctorProfile from '@/components/atom/icon/DefaultDoctorProfile';
import LazyImage from '@/components/molecules/LazyImage';
import QuestionItem from '@/components/molecules/QuestionList/QuestionItem';
import BlockQuestion from '@/components/molecules/QuestionList/QuestionItem/BlockQuestion';
import theme from '@/styles/theme';
import { QuestionAnsweredStatus, QuestionStatus } from '@/types/bff/gql-schema';
import { QnaQuestionMobileCard } from '@/types/qna';
import { QuestionSearchResultVo } from '@/types/search';

export interface QuestionItemProps {
  // Todo Vo로 통일 필요
  questionCard: QnaQuestionMobileCard | QuestionSearchResultVo;
  onClickQuestion: (questionId: number | string) => void;
  itemStyle?: React.CSSProperties;
}

const SearchQuestionItem: FunctionComponent<QuestionItemProps> = ({
  questionCard,
  onClickQuestion,
  itemStyle,
}) => {
  const { questionPid, isBlockedByMe } = questionCard.question;

  return (
    <QuestionWrapper
      onClick={() => {
        !isBlockedByMe && onClickQuestion(questionPid);
      }}
      style={itemStyle}
    >
      <>
        {/* 내가 차단한 유저의 질문 */}
        {isBlockedByMe ? (
          <BlockQuestion />
        ) : (
          <QuestionItem
            isPaidQuestion={false}
            key={questionPid}
            questionCard={questionCard}
            onClickQuestion={() => onClickQuestion(questionPid)}
          >
            <QuestionItem.BottomLeft>
              {questionCard.answeredStatus ===
              QuestionAnsweredStatus.Answered ? (
                <QuestionBottomAnswerStatus>
                  {/* 답변한 의사 프로필/카운트 (최대 5개) */}
                  <QuestionDoctorImageWrapper>
                    {questionCard.answererProfileImageUrls
                      .slice(0, 5)
                      .map((image, key) => (
                        <QuestionDoctorImage
                          imageKey={key}
                          key={`answered-doctor-${key}`}
                        >
                          <LazyImage
                            width={28}
                            height={28}
                            objectFit={'cover'}
                            loader={<DefaultDoctorProfile />}
                            src={image}
                            alt={'답변한 의사 프로필 이미지'}
                          />
                        </QuestionDoctorImage>
                      ))}
                  </QuestionDoctorImageWrapper>
                  {questionCard.answererCount}개의 답변
                </QuestionBottomAnswerStatus>
              ) : questionCard.question.status !==
                QuestionStatus.AwaitingBasicAnswer ? (
                // 답변 중 / 답변 확인 중
                // 목록
                <QuestionBottomAnswerStatus
                  fontColor={
                    questionCard.answeredStatus ===
                    QuestionAnsweredStatus.Answering
                      ? theme.color.primary500
                      : theme.color.blue500
                  }
                >
                  <CustomLottieIcon
                    width={24}
                    height={24}
                    animationData={
                      questionCard.answeredStatus ===
                      QuestionAnsweredStatus.Answering
                        ? OngoingLottie
                        : WaitLottie
                    }
                    style={{ marginRight: 8 }}
                  />
                  {questionCard.answeredStatusText}
                </QuestionBottomAnswerStatus>
              ) : (
                <></>
              )}
            </QuestionItem.BottomLeft>
          </QuestionItem>
        )}
      </>
    </QuestionWrapper>
  );
};

export default SearchQuestionItem;

const QuestionWrapper = styled.div`
  ${({ theme }) => `
    background: ${theme.color.white};
    `};
`;

const QuestionBottomAnswerStatus = styled.div<{ fontColor?: string }>`
  display: flex;
  align-items: center;

  ${({ theme, fontColor }) => `
    ${theme.typography.UI14SB};
    color: ${fontColor ?? theme.color.gray700};
  `};

  & > div {
    margin-right: 8px;
  }
`;

const QuestionDoctorImageWrapper = styled.div`
  display: flex;
  position: relative;
  margin-right: 8px;
`;

const QuestionDoctorImage = styled.div<{ imageKey: number }>`
  img {
    border: 2px solid white;
  }

  ${({ imageKey }) => `
    margin-left: -${imageKey ? 8 : 0}px;
    z-index: ${5 - imageKey};
  `};
`;
